import { SECOND_MS } from '#common/time';
import { PeriodicTaskBase } from '#common/util';
const DEFAULT_PERMISSIONS_REFETCH_INTERVAL_MS = SECOND_MS * 20;
export function createFilePermissionsSynchronizer(permissionsProvider, filePermissionsWasm) {
    return new FilePermissionsSynchronizerImpl(permissionsProvider, filePermissionsWasm);
}
class FilePermissionsSynchronizerImpl extends PeriodicTaskBase {
    permissionsProvider;
    filePermissionsWasm;
    constructor(permissionsProvider, filePermissionsWasm) {
        super('FilePermissionsSynchronizer', DEFAULT_PERMISSIONS_REFETCH_INTERVAL_MS);
        this.permissionsProvider = permissionsProvider;
        this.filePermissionsWasm = filePermissionsWasm;
    }
    async execute() {
        await this.doSync(false);
    }
    async sync(force) {
        await this.doSync(force);
    }
    async doSync(force) {
        const cryptoKeys = await this.permissionsProvider.getCryptoKeys();
        const principalCrypto = cryptoKeys.principalCrypto;
        const isAdmin = cryptoKeys.isAdmin;
        await this.filePermissionsWasm.refreshAccess(principalCrypto, isAdmin, force);
    }
}
